import { lazyFrame, isScrolledIntoView } from './utils';

export function observer() {
    function checkScroll() {
        const $list = document.querySelectorAll('.js-lazyFrame');

        $list.forEach($item => {
            if (isScrolledIntoView($item)) {
                lazyFrame($item);
            }
        });

        if ($list.length === 0) {
            window.removeEventListener('scroll', checkScroll);
        }
    }

    window.addEventListener('scroll', checkScroll);
    checkScroll();
}
